import { render } from "./recycle.vue?vue&type=template&id=10a6c9d4"
import script from "./recycle.vue?vue&type=script&lang=js"
export * from "./recycle.vue?vue&type=script&lang=js"

import "./recycle.vue?vue&type=style&index=0&id=10a6c9d4&lang=less"

import exportComponent from "D:\\wwwroot\\vant\\lan_v3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__